import axios from 'axios'
import forge from 'node-forge'
import { mockedTokensIcons } from '../components/mockedData'

// Normaliza para busqueda: saca acentos/diacriticos y baja a minusculas, para
// que "jose" matchee "Jose", "José" y "JOSÉ". Un .includes() sobre el texto
// normalizado da busqueda parcial, insensible a acentos y mayusculas. Se usa en
// la agenda y en el dropdown de contactos.
export const normalizeText = (value) =>
  String(value ?? '')
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .toLowerCase()

// Titulos de pagina normalizados, en ingles. Antes salia de capitalizar el
// segmento de la ruta ("Agenda", "Wallets"); ahora es un nombre real.
const PAGE_TITLES = {
  home: 'Home',
  transactions: 'My Transfers',
  wallets: 'My Accounts',
  agenda: 'My Contacts',
  profile: 'My Profile',
}

export const getPageTitle = (pathname) => {
  const segments = String(pathname || '')
    .split('/')
    .filter(Boolean)
  const base = segments[0]
  if (!base) return ''
  if (base === 'transactions' && segments.length > 1) return 'Transfer detail'
  if (base === 'home' && segments[1] === 'multiple-payments')
    return 'Payment detail'
  return PAGE_TITLES[base] || base.charAt(0).toUpperCase() + base.slice(1)
}

export const formatLargeText = (text, maxLength = 60) => {
  if (!text) return

  if (text.length > maxLength) {
    return text.slice(0, 8) + '...' + text.slice(-4)
  }

  return text
}

export function copyToClipboard(text) {
  navigator.clipboard.writeText(text)
}

export function formatDate(date) {
  return new Date(date).toLocaleString()
}

// Format date from block timestamp for transactions
export const formatBlockTimestamp = (timestamp) => {
  if (!timestamp) return '-'

  const cleanTimestamp = timestamp.replace(/"/g, '')

  const date = new Date(cleanTimestamp)

  if (isNaN(date.getTime())) return '-'

  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  })
}

export function validateEmail(email) {
  const regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

  return regexEmail.test(email)
}

export function formatTimeUnix(unixTimestamp) {
  if (!unixTimestamp) return '-'

  const date = new Date(unixTimestamp * 1000)
  return date.toLocaleString(undefined, {
    timeZoneName: 'short',
  })
}

export async function getToken() {
  const encryptedUsername = encryptText('develone')
  const encryptedPassword = encryptText('develonepwd')

  try {
    var data = JSON.stringify({
      user: encryptedUsername,
      password: encryptedPassword,
    })

    const config = {
      method: 'POST',
      url: `${process.env.REACT_APP_CORE_TENUI_URL}/token`,
      headers: {
        'Content-Type': 'application/json',
      },
      data,
    }

    const response = await axios(config)
    localStorage.setItem('tokenContraPago', response.data.token)
    return true
  } catch (error) {
    return false
  }
}

export function truncateWithEllipsis(str, maxLength, ellipsis = '...') {
  if (typeof str !== 'string') return str
  if (str.length <= maxLength) return str
  return str.slice(0, maxLength) + ellipsis
}

export function getTokenIcon(tokenName) {
  return mockedTokensIcons.find((token) => token.name === tokenName)?.logo
}

export function encryptText(text) {
  const publicKeyPem = `-----BEGIN PUBLIC KEY-----\n${process.env.REACT_APP_PUBLIC_KEY.match(
    /.{1,64}/g
  ).join('\n')}\n-----END PUBLIC KEY-----`
  const publicKey = forge.pki.publicKeyFromPem(publicKeyPem)

  const encryptedBytesText = publicKey.encrypt(text, 'RSA-OAEP', {
    md: forge.md.sha256.create(),
  })
  const encryptedText = forge.util.encode64(encryptedBytesText)

  return encryptedText
}

export function validateExcelFile(file) {
  if (!file) return false

  const allowedExtensions = ['xlsx', 'xls']
  const fileExtension = file.name.split('.').pop().toLowerCase()

  return allowedExtensions.includes(fileExtension)
}
